import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { Button, Card } from '../components/ui';

export default function PaymentSuccess() {
  const [status, setStatus] = useState<'checking' | 'paid' | 'no-order' | 'timeout'>('checking');
  const [message, setMessage] = useState('Comprobando pago...');
  const navigate = useNavigate();

  useEffect(() => {
    const orderId = localStorage.getItem('pendingOrderId');
    if (!orderId) {
      setStatus('no-order');
      setMessage('No se encontró orden pendiente.');
      return;
    }
    let attempts = 0;
    const poll = async () => {
      try {
        const res = await api.get(`/orders/${orderId}`);
        const ord = res.data.order;
        if (ord?.status === 'paid') {
          setStatus('paid');
          setMessage('¡Pago confirmado! Redirigiendo...');
          localStorage.removeItem('pendingOrderId');
          setTimeout(() => navigate('/dashboard'), 2000);
          return;
        }
      } catch {}
      attempts += 1;
      if (attempts > 20) {
        setStatus('timeout');
        setMessage('No se confirmó el pago aún. Puedes revisar tu dashboard.');
        return;
      }
      setTimeout(poll, 3000);
    };
    poll();
  }, [navigate]);

  return (
    <div className="max-w-lg mx-auto px-4 py-16">
      <Card className="text-center animate-fade-in">
        {status === 'checking' && (
          <>
            <div className="animate-spin h-16 w-16 border-2 border-rs-accent border-t-transparent rounded-full mx-auto mb-6" />
            <h1 className="font-display text-2xl font-bold text-gray-100 mb-2">Procesando pago</h1>
            <p className="text-gray-400">{message}</p>
          </>
        )}
        {status === 'paid' && (
          <>
            <div className="w-16 h-16 rounded-full bg-emerald-500/20 flex items-center justify-center mx-auto mb-6">
              <svg className="w-8 h-8 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h1 className="font-display text-2xl font-bold text-gray-100 mb-2">¡Pago confirmado!</h1>
            <p className="text-gray-400 mb-6">{message}</p>
            <div className="flex gap-3 justify-center">
              <Button onClick={() => navigate('/dashboard')}>Ir al dashboard</Button>
              <Button variant="outline" onClick={() => navigate('/licenses')}>Ver licencias</Button>
            </div>
          </>
        )}
        {(status === 'no-order' || status === 'timeout') && (
          <>
            <div className="w-16 h-16 rounded-full bg-amber-500/20 flex items-center justify-center mx-auto mb-6">
              <svg className="w-8 h-8 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <h1 className="font-display text-2xl font-bold text-gray-100 mb-2">Estado del pago</h1>
            <p className="text-gray-400 mb-6">{message}</p>
            <div className="flex gap-3 justify-center">
              <Button onClick={() => navigate('/dashboard')}>Ir al dashboard</Button>
              <Button variant="outline" onClick={() => navigate('/licenses')}>Ver licencias</Button>
              <Button variant="ghost" onClick={() => navigate('/')}>Volver al inicio</Button>
            </div>
          </>
        )}
      </Card>
    </div>
  );
}
